import React, { useContext, useEffect, useState } from "react";
import "./deliveryStatus.scss";
import { Grid } from "@material-ui/core";

import { withTranslation, useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import OrderDetails from "../../Components/orderStatusComponents/orderDetails/OrderDetails";
import PaymentStatus from "../../Components/orderStatusComponents/PaymentStatus";
import StatusHeader from "../../Components/orderStatusComponents/header2/StatusHeader";
import StateContext from "../../StateContext";
import ShareInvoiceQrcode from "../../Components/shareInvoiceQrcode/shareInvoiceQrcode";
import NotifyPermisssionPopup from "../../Components/notifyPermisssionPopup/notifyPermisssionPopup";
import DispatchContext from "../../DispatchContext";
import AddsSlider from "../../Components/addsBanners/addsSlider";
import DeliveryInfoModal from "../../Components/deliveryInfoModal/deliveryInfoModal";
import PartialPaymentSummary from "../../Components/partialPaymentSummary/PartialPaymentSummary";
import { Backdrop } from "@mui/material";
import { formatMoney } from "../../helper/customeObj";

function DeliveryStatus({
  invoiceable,
  invoiceDetails,
  orderStatus,
  addsInfo,
}) {
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const { type } = useParams();
  const [showModal, setShowModal] = useState(false);
  let selfServe =
    invoiceable?.service_type == "PickUp"
      ? true
      : invoiceable?.info?.qrcode?.section?.hotel?.self_serve ?? false;

  useEffect(() => {
    let checkSubscription = Boolean(
      localStorage.getItem(`service_worker_${appState?.storeInfo?.slug}`)
    );
    if (
      checkSubscription == false &&
      invoiceable.service_type == "HotelOrder" &&
      selfServe
    ) {
      appDispatch({
        type: "setAllowNotificationPopupMode",
        allowNotificationPopupMode: true,
      });
    }
  }, [appState.pushSubscription]);
  useEffect(() => {
  }, [orderStatus]);

  const isPartial = Boolean(invoiceDetails?.is_partial);
  const totalBill = Number(invoiceable?.amount ?? 0);
  const currencyCode =
    invoiceDetails?.business?.currency ||
    appState.storeInfo?.currencyCode ||
    "KWD";

  return (
    <>
      <Grid
        id="deliveryStatus"
        container
        justifyContent="center"
        className={` vh-100 ${
          appState.langValue === "ar" ? "directionRtl" : ""
        }`}
      >
        {/* {showModal && (
          <DeliveryInfoModal
            invoiceable={invoiceable}
            open={showModal}
            setOpen={setShowModal}
          />
        )} */}

        {showModal && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showModal}
          ></Backdrop>
        )}

        <Grid className="centerColumn" item xs={12} md={6}>
          <StatusHeader invoiceable={invoiceable} orderStatus={orderStatus} />

          {invoiceable?.integration &&
            <p onClick={()=> setShowModal(true)} className="cursor-pointer px-2">
              {" "}
               {t("OrderStatus.Deliver-by")} <b>{invoiceable?.integration?.integration?.type?.name}</b>{" "}
            </p>
          }
          {addsInfo != null && (
            <span
              className={`${
                addsInfo.length > 1
                  ? ``
                  : `d-flex align-items-center justify-content-center`
              }`}
            >
              {" "}
              <AddsSlider addsInfo={addsInfo} />{" "}
            </span>
          )}
          {/* <PaymentStatus invoiceable={invoiceable} /> */}
          <OrderDetails invoiceDetails={invoiceDetails} />

          <hr />
          <div className="col-12 mb-1">
            <div className="px-1 d-flex align-items-center justify-content-between">
              <h5 className="mt-2 familysora700">
                {t("invoice.Total-Bill")}
              </h5>
              <h5 className="familysora700">
                {formatMoney(
                  isPartial || invoiceDetails?.payment_method === "PARTIAL"
                    ? totalBill
                    : invoiceDetails?.payment_method != null
                      ? invoiceDetails.amount
                      : invoiceable.amount,
                  currencyCode,
                  appState.langValue
                )}
              </h5>
            </div>
          </div>
          <PartialPaymentSummary
            invoiceDetails={invoiceDetails}
            className="col-12 mb-3"
          />
        </Grid>
        {appState.shareInvoiceQrcode && (
          <ShareInvoiceQrcode type={type} invoiceDetails={invoiceDetails} />
        )}
        {appState.allowNotificationPopupMode &&
          invoiceable.service_type == "HotelOrder" &&
          selfServe && (
            <NotifyPermisssionPopup
              invoiceDetails={invoiceDetails}
              invoiceable={invoiceable}
              selfServe={selfServe}
            />
          )}
      </Grid>
    </>
  );
}

  export default withTranslation()(DeliveryStatus);
